<template>
  <!-- Use h-11 (not the .top-bar class) for height: the page-layout `.top-bar > *` rule
       forces width:100% on every child, which would split this header 50/50 and pull the
       close button to mid-panel instead of flush right. -->
  <div class="flex items-center justify-between border-b border-gpx_gray-900 bg-white px-4 h-11 min-h-[45px] transition-[height] duration-200">
    <EditableText
      v-model="titleValue"
      :editable="editable"
      textClass="text-lg font-medium text-gpx_slate-100"
      inputClass="text-lg font-medium text-gpx_slate-100"
      headingTag="h2"
    />
    <div class="flex items-center space-x-2">
      <slot name="actions"></slot>
      <button
        type="button"
        class="text-gpx_gray-700 hover:text-gpx_gray-200 focus:outline-none"
        @click="$emit('close')"
        aria-label="Close"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import EditableText from '@/components/_common/EditableText.vue';

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  editable: {
    type: Boolean,
    default: true
  }
});

const emit = defineEmits(['update:title', 'close']);
const titleValue = ref(props.title);
const needToUpdate = ref(true);

watch(() => props.title, (value) => {
  if (value) {
    needToUpdate.value = false;
    titleValue.value = value;
  }
});

// When v-model is updated, notify the parent about the change
watch(titleValue, (value) => {
  if (needToUpdate.value === false) {
    needToUpdate.value = true;
    return;
  }
  emit('update:title', value);
});
</script>
